import React from "react";

export default function OnDemandBuild({ data }) {
  if (!data || !data.boxes || data.boxes.length === 0) {
    return null;
  }
  return (
    <>
      <section className="ondemand-build-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="blink-build-content">
                <h2 className="heading center-heading">{data.title}</h2>
                <p className="sub-heading">{data.description}</p>
              </div>
            </div>

            <div className="col-lg-10 col-md-12">
              <div className="row">
                {data.boxes.map((box, index) => (
                  <div className="col-lg-6 col-md-6" key={index}>
                    <div className="blink-build-box ondemand-build-box">
                      <img src={box?.image} alt="build" />
                      <span>{box?.title}</span>
                      <small>{box?.desc}</small>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
